module.exports = __webpack_public_path__ + "img/404NotFound.b9b41c4a.png";